import React, { useState } from "react";
import {
    Box,
    List,
    ListItemText,
    Paper,
    ListSubheader,
    ListItemButton,
    ListItemIcon,
    Typography,
    Grid,
    useTheme,
    useMediaQuery,
    Tabs,
    Tab,
    Menu,
    MenuItem,
} from "@mui/material";

import PersonIcon from "@mui/icons-material/Person";
import AssignmentIcon from "@mui/icons-material/Assignment";
import NoteIcon from "@mui/icons-material/StickyNote2";
import LinkIcon from "@mui/icons-material/Link";
import ImageIcon from "@mui/icons-material/Image";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import ResidentProfileOverview from "./residentProfileOverview";
import ImageEntryForm from "../../../../../platform/components/business/image/imageEntryForm";

// ⭐ NEW MODULES YOU WILL ADD  
import CarePlanTab from "../../../resident/tabs/carePlanTab";
import DailyNotesTab from "../../../resident/tabs/dailyNotesTab";
import VitalsTab from "../../../resident/tabs/vitalsTab";
import MedicationTab from "../../../resident/medications/medicationTab";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MedicationIcon from "@mui/icons-material/Medication";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import IncidentReport from "../../../resident/tabs/IncidentReport";
import ResidentDocumentsTab from "./residentDocumentsTab";
import ResidentStaffAssignmentTab from "./residentStaffAssignmentTab";
import GroupsIcon from "@mui/icons-material/Groups";


const ResidentDetailHorizontalTab = ({ resident, businessId, onCarePlanSaved }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [selectedIndex, setSelectedIndex] = useState(0);
    const hasResident = Boolean(resident && resident.id);
    // if (!resident) {
    //     return (
    //         <Typography sx={{ p: 2 }}>
    //             Add or Select a resident to view details.
    //         </Typography>
    //     );
    // }

    // ⭐ NEW UPDATED MENU
    const menuItems = [
        { label: "Resident Face Sheet", mobileLabel: "Face Sheet", index: 0, icon: <PersonIcon fontSize="small" /> },
        { label: "Staff Assignment", mobileLabel: "Assignment", index: 1, icon: <GroupsIcon fontSize="small" /> },
        { label: "Preliminary Service Plan", mobileLabel: "Service Plan", index: 2, icon: <AssignmentIcon fontSize="small" /> },
        { label: "Progress Notes", mobileLabel: "Notes", index: 3, icon: <NoteIcon fontSize="small" /> },
        { label: "Medication & MAR", mobileLabel: "Medication", index: 4, icon: <MedicationIcon fontSize="small" /> },
        { label: "Vitals", mobileLabel: "Vitals", index: 5, icon: <MonitorHeartIcon fontSize="small" /> },
        { label: "Incident Report", mobileLabel: "Incident", index: 6, icon: <ReportProblemIcon fontSize="small" /> },
        { label: "Documents (Care plan, Assessment...)", mobileLabel: "Docs (...)", index: 7, icon: <LinkIcon fontSize="small" /> },
        { label: "Image", mobileLabel: "Image", index: 8, icon: <ImageIcon fontSize="small" /> },
    ];
    const MOBILE_VISIBLE_TAB_COUNT = 3;
    const mobileVisibleItems = menuItems.slice(0, MOBILE_VISIBLE_TAB_COUNT);
    const mobileOverflowItems = menuItems.slice(MOBILE_VISIBLE_TAB_COUNT);
    const isOverflowSelected = mobileOverflowItems.some((item) => item.index === selectedIndex);
    const mobileTabValue = isOverflowSelected ? false : selectedIndex;
    const overflowActiveItem = mobileOverflowItems.find((item) => item.index === selectedIndex) || null;
    const [moreAnchorEl, setMoreAnchorEl] = useState(null);
    const closeMoreMenu = () => setMoreAnchorEl(null);


    const handleMenuItemClick = (index) => {
        setSelectedIndex(index);
    };

    return (
        <Grid container spacing={2}>
            {/* LEFT MENU */}
            <Grid item xs={12} md={3}>
                {isMobile ? (
                    <Box
                        sx={{
                            mb: 1.5,
                            position: "sticky",
                            top: "calc(var(--business-header-height, 0px) + 4px)",
                            zIndex: (t) => t.zIndex.appBar - 1,
                            bgcolor: "background.paper",
                            border: (t) => `1px solid ${t.palette.divider}`,
                            borderRadius: 2,
                            boxShadow: "0 6px 14px rgba(15,23,42,0.08)",
                        }}
                    >
                        <Tabs
                            value={mobileTabValue}
                            onChange={(e, next) => {
                                if (next === "more") {
                                    setMoreAnchorEl(e.currentTarget);
                                    return;
                                }
                                handleMenuItemClick(next);
                                closeMoreMenu();
                            }}
                            variant="fullWidth"
                            aria-label="Resident detail tabs"
                            sx={{
                                minHeight: 46,
                                "& .MuiTab-root": {
                                    minHeight: 46,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    fontSize: 11.5,
                                    px: 0.5,
                                    minWidth: 0,
                                },
                            }}
                        >
                            {mobileVisibleItems.map((item) => (
                                <Tab
                                    key={item.index}
                                    value={item.index}
                                    icon={item.icon}
                                    iconPosition="start"
                                    label={item.mobileLabel || item.label}
                                />
                            ))}
                            {mobileOverflowItems.length > 0 && (
                                <Tab value="more" label="More" />
                            )}
                        </Tabs>
                        <Menu
                            anchorEl={moreAnchorEl}
                            open={Boolean(moreAnchorEl)}
                            onClose={closeMoreMenu}
                            keepMounted
                            disableScrollLock
                        >
                            {mobileOverflowItems.map((item) => (
                                <MenuItem
                                    key={item.index}
                                    selected={selectedIndex === item.index}
                                    onClick={() => {
                                        handleMenuItemClick(item.index);
                                        closeMoreMenu();
                                    }}
                                >
                                    {item.mobileLabel || item.label}
                                </MenuItem>
                            ))}
                        </Menu>
                        {isOverflowSelected && overflowActiveItem && (
                            <Box sx={{ px: 1, pb: 0.75 }}>
                                <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
                                    Selected: {overflowActiveItem.mobileLabel || overflowActiveItem.label}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                ) : (
                    // Desktop Sidebar
                    <Paper
                        elevation={0}
                        sx={{
                            position: "sticky",
                            top: 16,
                            height: "calc(100vh - 140px)",
                            overflowY: "auto",
                            borderRight: `1px solid ${theme.palette.divider}`,
                            borderRadius: 2,
                        }}
                    >
                        <List
                            dense
                            subheader={
                                <ListSubheader
                                    component="div"
                                    sx={{ fontWeight: 700, bgcolor: "transparent" }}
                                >
                                    Resident Menu
                                </ListSubheader>
                            }
                            sx={{
                                py: 1,
                                "& .MuiListItemButton-root": {
                                    borderRadius: 1.5,
                                    mx: 1,
                                    my: 0.5,
                                },
                                "& .Mui-selected": {
                                    bgcolor: theme.palette.action.selected,
                                },
                            }}
                        >
                            {menuItems.map((item) => (
                                <ListItemButton
                                    key={item.index}
                                    selected={selectedIndex === item.index}
                                    onClick={() => handleMenuItemClick(item.index)}
                                >
                                    <ListItemIcon sx={{ minWidth: 32 }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.label}
                                        primaryTypographyProps={{
                                            fontWeight:
                                                selectedIndex === item.index ? 700 : 500,
                                            fontSize: 14,
                                        }}
                                    />
                                </ListItemButton>
                            ))}
                        </List>
                    </Paper>
                )}
            </Grid>

            <Grid item xs={12} md={9} sx={{ p: 2 }}>
                {!hasResident ? (
                    <Paper
                        elevation={0}
                        sx={{
                            p: 4,
                            textAlign: "center",
                            border: `1px dashed ${theme.palette.divider}`,
                        }}
                    >
                        <Typography variant="h6" gutterBottom>
                            No resident selected
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Please add or select a resident to view details.
                        </Typography>
                    </Paper>
                ) : (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        {selectedIndex === 0 && <ResidentProfileOverview resident={resident} businessId={businessId} />}
                        {selectedIndex === 1 && (
                            <ResidentStaffAssignmentTab resident={resident} businessId={businessId} />
                        )}
                        {selectedIndex === 2 && (
                            <CarePlanTab
                                resident={resident}
                                onCarePlanSaved={onCarePlanSaved}
                            />
                        )}
                        {selectedIndex === 3 && (
                            <DailyNotesTab residentId={resident.id} />
                        )}
                        {selectedIndex === 4 && (
                            <MedicationTab residentId={resident.id} />
                        )}
                        {selectedIndex === 5 && (
                            <VitalsTab residentId={resident.id} />
                        )}
                        {selectedIndex === 6 && (
                            <IncidentReport resident={resident} />
                        )}
                        {selectedIndex === 7 && (
                            <ResidentDocumentsTab residentId={resident.id} />
                        )}
                        {selectedIndex === 8 && (
                            <ImageEntryForm
                                singleImageMode={true}
                                avatar={true}
                                residentId={resident.id}
                                residentImageUrl={resident?.image?.url || resident?.photoUrl || ""}
                                isDisabled={false}
                            />
                        )}
                    </LocalizationProvider>
                )}
            </Grid>



        </Grid>
    );
};

export default ResidentDetailHorizontalTab;
